import type { ChartConfig } from "@v1/components/designSystem/shadcn/core/chart";
import type {
  ChartInterval,
  SelectedTimePeriod,
} from "schemas/utils/analytics";

import { getRangesFromTimePeriod } from "analytics-utils/analytics";
import { convertDaysToMs } from "replo-utils/lib/datetime";

type ChartIntervalOption = {
  label: string;
  value: ChartInterval;
};

const HOUR_OPTION: ChartIntervalOption = {
  value: "hour",
  label: "hour",
};
const DAY_OPTION: ChartIntervalOption = { value: "day", label: "day" };

export function getChartIntervalOptions(
  selectedTimePeriod: SelectedTimePeriod,
  timeZone: string,
) {
  const { updatedRanges } = getRangesFromTimePeriod({
    selectedTimePeriod,
    timeZone,
  });
  const { startDatetime, endDatetime } = updatedRanges.mainRange;
  const start = new Date(startDatetime);
  const end = new Date(endDatetime);

  const rangeInDays = Math.ceil(
    (end.getTime() - start.getTime()) / convertDaysToMs(1),
  );

  let intervalOptions: ChartIntervalOption[] = [];

  if (rangeInDays <= 1) {
    intervalOptions = [HOUR_OPTION];
  } else if (rangeInDays <= 31) {
    intervalOptions = [HOUR_OPTION, DAY_OPTION];
  } else {
    intervalOptions = [DAY_OPTION];
  }

  return { intervalOptions, rangeInDays };
}

export const CHART_COLORS = {
  previousPeriod: "#A5C8FF",
  thisPeriod: "#000",
  labelOutside: "#94A2B8",
  benchmarks: "#5046E6",
};

export const CHART_CONFIG_DEFAULT: ChartConfig = {
  primaryPeriod: {
    label: "This Period",
    color: CHART_COLORS.thisPeriod,
  },
  secondaryPeriod: {
    label: "Previous Period",
    color: CHART_COLORS.previousPeriod,
  },
};

export const CHART_CONFIG_BENCHMARKS: ChartConfig = {
  primaryPeriod: {
    label: "This Period",
    color: CHART_COLORS.thisPeriod,
  },
  secondaryPeriod: {
    label: "Benchmarks",
    color: CHART_COLORS.benchmarks,
  },
};
